import { z } from "zod";
import { REALTIME_SCOPES } from "./scope.js";

const SCOPES_REQUIRING_TARGET: ReadonlyArray<string> = [
	REALTIME_SCOPES.CONVERSATION,
	REALTIME_SCOPES.PHOTO_ROULETTE,
	REALTIME_SCOPES.VOICE_GUESSER,
	REALTIME_SCOPES.WALKIE_TALKIE,
];

export const realtimeTicketBodySchema = z
	.object({
		scope: z.enum([
			REALTIME_SCOPES.CONVERSATION,
			REALTIME_SCOPES.INBOX,
			REALTIME_SCOPES.PHOTO_ROULETTE,
			REALTIME_SCOPES.VOICE_GUESSER,
			REALTIME_SCOPES.WALKIE_TALKIE,
		]),
		target: z.string().optional(),
	})
	.refine((data) => !SCOPES_REQUIRING_TARGET.includes(data.scope) || !!data.target, {
		message: "target is required for this scope",
		path: ["target"],
	});

export type RealtimeTicketBody = z.infer<typeof realtimeTicketBodySchema>;

export const realtimeTicketPayloadSchema = z.object({
	user_id: z.string(),
	scope: z.enum([
		REALTIME_SCOPES.CONVERSATION,
		REALTIME_SCOPES.INBOX,
		REALTIME_SCOPES.PHOTO_ROULETTE,
		REALTIME_SCOPES.VOICE_GUESSER,
		REALTIME_SCOPES.WALKIE_TALKIE,
	]),
	target: z.string().optional(),
	typ: z.literal("ws-ticket"),
});

export type RealtimeTicketPayload = z.infer<typeof realtimeTicketPayloadSchema>;
